import { MergeFormSection } from "components/MainSectionTemplate/types";
import { ContactFormState } from "contact/models";
import React from "react";

export const homeAddressSeciton = (
  existingContact: ContactFormState,
  sourceContact: ContactFormState,
  currentContact: ContactFormState,
  setCurrentContact: (Contact: ContactFormState) => void
): MergeFormSection => ({
  key: "address",
  title: RESX.Contact.HomeAddress,
  fields: [{
    key: "addressLine1",
    label: RESX.Address.AddressLine + " 1",
    currentValue: currentContact.homeAddress.addressLine1,
    existingValue: existingContact.homeAddress.addressLine1,
    sourceValue: sourceContact.homeAddress.addressLine1,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        addressLine1: sourceContact.homeAddress.addressLine1,
      },
    }),
    onExistingClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        addressLine1: existingContact.homeAddress.addressLine1,
      },
    }),
  }, {
    key: "addressLine2",
    label: RESX.Address.AddressLine + " 2",
    currentValue: currentContact.homeAddress.addressLine2,
    existingValue: existingContact.homeAddress.addressLine2,
    sourceValue: sourceContact.homeAddress.addressLine2,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        addressLine2: sourceContact.homeAddress.addressLine2,
      },
    }),
    onExistingClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        addressLine2: existingContact.homeAddress.addressLine2,
      },
    }),
  }, {
    key: "postalCode",
    label: RESX.Address.PostalCode,
    currentValue: currentContact.homeAddress.postalCode,
    existingValue: existingContact.homeAddress.postalCode,
    sourceValue: sourceContact.homeAddress.postalCode,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        postalCode: sourceContact.homeAddress.postalCode,
      },
    }),
    onExistingClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        postalCode: existingContact.homeAddress.postalCode,
      },
    }),
  }, {
    key: "city",
    label: RESX.Address.City,
    currentValue: currentContact.homeAddress.city,
    existingValue: existingContact.homeAddress.city,
    sourceValue: sourceContact.homeAddress.city,
    isEmpty: (v) => !v,
    render: (value) => <span>{value}</span>,
    onSourceClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        city: sourceContact.homeAddress.city,
      },
    }),
    onExistingClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        city: existingContact.homeAddress.city,
      },
    }),
  }, {
    key: "country",
    label: RESX.Address.Country,
    currentValue: currentContact.homeAddress.country,
    existingValue: existingContact.homeAddress.country,
    sourceValue: sourceContact.homeAddress.country,
    isEmpty: (v) => !v,
    render: (value: server.dto.Country) => <span>{value.name}</span>,
    onSourceClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        country: sourceContact.homeAddress.country,
      },
    }),
    onExistingClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        country: existingContact.homeAddress.country,
      },
    }),
  }, {
    key: "state",
    label: RESX.Address.State,
    currentValue: currentContact.homeAddress.state,
    existingValue: existingContact.homeAddress.state,
    sourceValue: sourceContact.homeAddress.state,
    isEmpty: (v) => !v,
    render: (value: server.dto.State) => <span>{value.name}</span>,
    onSourceClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        state: sourceContact.homeAddress.state,
      },
    }),
    onExistingClick: () => setCurrentContact({
      ...currentContact,
      homeAddress: {
        ...currentContact.homeAddress,
        state: existingContact.homeAddress.state,
      },
    }),
  }]
});